import { render } from "./AjoutProspect.vue?vue&type=template&id=3f125b24&scoped=true"
import script from "./AjoutProspect.vue?vue&type=script&lang=js"
export * from "./AjoutProspect.vue?vue&type=script&lang=js"

import "./AjoutProspect.vue?vue&type=style&index=0&id=3f125b24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f125b24"]])

export default __exports__